export const VIEW_MODE = {
  QUESTION: "question",
  STATEMENT_RESULTS: "statement-results",
  GROUP_ARGUMENTS: "group-arguments",
  PARTY_ARGUMENTS: "party-arguments",
  RESULTS: "results",
};

export const USER_ROLES = {
  TEACHER: "teacher",
  ADMIN: "admin",
  SUPER_ADMIN: "super_admin",
};
